import React from "react";
import { BundleInterface } from "src/store/gh_market/bundlesSlice";
import Card from "src/componets/Card";
import ListForm from "../../Products/_partials/_ListForm";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectProductEntities, ProductInterface, selectProductIds } from "src/store/gh_market/productsSlice";
import { message } from "antd";
import { updateProducts } from "src/actions/gh_market/bundlesActions";
import { EntityId } from "@reduxjs/toolkit";

interface dataInterface {
  products: ProductInterface[],
  bundle_id: number
}

const _Products = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const products = useAppSelector(selectProductEntities);
  const productsIds = useAppSelector(selectProductIds);

  if (!bundle) {
    return null;
  }

  const data: dataInterface = {
    products: [],
    bundle_id: bundle.id
  };

  productsIds.forEach((id: any) => {
    const product = products[id];

    if (product) {
      data.products.push(product);
    }
  });

  function onFinish(data: dataInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(result: dataInterface) {
    if (!bundle) {
      return;
    }

    const id = bundle.id;
    const newData: any = { products: [] };
    const resultIds: EntityId[] = result.products.map((product: any) => product.id);

    result.products.forEach((product: any) => {
      newData.products.push({
        id: product.id,
        product_id: product.product_id,
        value: product.value,
      })
    });

    productsIds.forEach((id: EntityId) => {
      if (!resultIds.includes(id)) {
        newData.products.push({
          id: id,
          _destroy: true
        })
      }
    });

    const resultAction = await dispatch(updateProducts({ bundleId: id, data: newData }));

    if (updateProducts.fulfilled.match(resultAction)) {
      message.success('Products updated successfully');
    }

    if (updateProducts.rejected.match(resultAction)) {
      const error = Array.isArray(resultAction.payload) ? resultAction.payload[0] : resultAction.error.message;
      message.error(error);
    }
  }

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Products</h4>

        <div style={{ maxWidth: 480 }}>
          <ListForm
            onFinish={onFinish}
            data={data}
          />
        </div>
      </Card>
    </>
  );
}

export default _Products;
